import styled from 'styled-components';

const PhotoStrip = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

export default PhotoStrip;
